
import React, { useEffect } from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import Contact from '@/components/Contact';
import ParticleBackground from '@/components/ParticleBackground';
import SEOMetaTags from '@/components/SEOMetaTags';

const ContactPage = () => {
  // Contact page specific structured data
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Synthreo | Get in Touch with Our Team",
    "description": "Contact Synthreo for questions about our AI solutions. Reach us at info@synthreo.ai or +1 (602) 649-4979.",
    "url": "https://synthreo.ai/company/contact",
    "mainEntity": {
      "@type": "Organization",
      "name": "Synthreo, Inc.",
      "url": "https://synthreo.ai",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+1-602-649-4979",
          "contactType": "customer service",
          "email": "info@synthreo.ai",
          "availableLanguage": "English",
          "areaServed": "US"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "5227 N 7th St",
        "addressLocality": "Phoenix",
        "addressRegion": "AZ",
        "postalCode": "85014-2802",
        "addressCountry": "US"
      },
      "sameAs": [
        "https://facebook.com/synthreo",
        "https://linkedin.com/company/synthreo",
        "https://instagram.com/synthreo"
      ]
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-synthreo-black text-white overflow-hidden">
      <SEOMetaTags 
        title="Contact Synthreo | Get in Touch with Our Team"
        description="Have questions about our AI solutions? Contact Synthreo today at info@synthreo.ai or +1 (602) 649-4979. Located at 5227 N 7th St, Phoenix, AZ 85014-2802."
        url="https://synthreo.ai/company/contact"
        canonical="https://synthreo.ai/company/contact"
        keywords="contact Synthreo, AI solutions contact, artificial intelligence support, Synthreo help, info@synthreo.ai, Phoenix Arizona"
        schema={contactSchema}
      />
      <ParticleBackground />
      <Navbar />
      <main className="flex-grow w-full">
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
